module.exports = __webpack_public_path__ + "static/img/img_avatar_example.5c81ce68.gif";